/**
 * Miscellaneous Icons
 * 
 * Icons that don't fit into other categories - various domain-specific
 * icons for specialized features.
 * 
 * Used by: Various specialized features throughout the app
 */

import { library } from "@fortawesome/fontawesome-svg-core";
import {
  // Daily Living & Personal Care
  faPlateUtensils as fadPlateUtensils,
  faUtensils as fadUtensils,
  faClothesHanger as fadClothesHanger,
  faToilet as fadToilet,
  faToothbrush as fadToothbrush,
  faBed as fadBed,
  
  // Accessibility & Support
  faUniversalAccess as fadUniversalAccess,
  faHandHoldingHand as fadHandHoldingHand,
  faHandsPraying as fadHandsPraying,
  
  // Education & Learning
  faSchool as fadSchool,
  faSchoolFlag as fadSchoolFlag,
  faChalkboardUser as fadChalkboardUser,
  faGraduationCap as fadGraduationCap,
  
  // Transportation & Location
  faTaxiBus as fadTaxiBus,
  faHousePersonLeave as fadHousePersonLeave,
  faMapLocation as fadMapLocation,
  faLocationDot as fadLocationDot,
  faEarthAmericas as fadEarthAmericas,
  faGlobe as fadGlobe,
  
  // Buildings & Places
  faBuilding as fadBuilding,
  faBuildingMemo as fadBuildingMemo,
  
  // Recreation & Activities
  faGamepadModern as fadGamepadModern,
  faHeart as fadHeart,
  
  // Data & Technology
  faDatabase as fadDatabase,
  faCode as fadCode,
  faCodeBranch as fadCodeBranch,
  faBrowser as fadBrowser,
  faLaptop as fadLaptop,
  faDesktop as fadDesktop,
  faTablet as fadTablet,
  faTv as fadTv,
  faMobile as fadMobile,
  faMobileScreen as fadMobileScreen,
  faWifi as fadWifi,
  faWifiSlash as fadWifiSlash,
  faVideo as fadVideo,
  
  // Performance & Cache (Admin)
  faFire as fadFire,
  faTachometerFast as fadTachometerFast,
  faSitemap as fadSitemap,
  
  // Miscellaneous
  faHandWave as fadHandWave,
  faLaptopFile as fadLaptopFile,
  faRectangleHistoryCircleUser as fadRectangleHistoryCircleUser,
  faLanguage as fadLanguage,
  faBullhorn as fadBullhorn,
  faFlask as fadFlask,
  faBug as fadBug,
  faSignOut as fadSignOut,
  faXmark as fadXmark,
  faCircleInfo as fadCircleInfo,
  faScrewdriverWrench as fadScrewdriverWrench,
  faCakeCandles as fadCakeCandles,
  faGavel as fadGavel,
  faSignalStream as fadSignalStream,
  faServer as fadServer,
  faPuzzlePiece as fadPuzzlePiece,
  faStopwatch as fadStopwatch,
  faRotate as fadRotate,
} from "@fortawesome/pro-duotone-svg-icons";

import {
  faHandWave as fatHandWave,
  faLaptopFile as fatLaptopFile,
  faArrowDown as fatArrowDown,
} from "@fortawesome/pro-thin-svg-icons";

export const loadMiscIcons = () => {
  // Duotone misc icons
  library.add(
    // Daily Living
    fadPlateUtensils,
    fadUtensils,
    fadClothesHanger,
    fadToilet,
    fadToothbrush,
    fadBed,
    
    // Accessibility
    fadUniversalAccess,
    fadHandHoldingHand,
    fadHandsPraying,
    
    // Education
    fadSchool,
    fadSchoolFlag,
    fadChalkboardUser,
    fadGraduationCap,
    
    // Transportation
    fadTaxiBus,
    fadHousePersonLeave,
    fadMapLocation,
    fadLocationDot,
    fadEarthAmericas,
    fadGlobe,
    
    // Buildings
    fadBuilding,
    fadBuildingMemo,
    
    // Recreation
    fadGamepadModern,
    fadHeart,
    
    // Technology
    fadDatabase,
    fadCode,
    fadCodeBranch,
    fadBrowser,
    fadLaptop,
    fadDesktop,
    fadTablet,
    fadTv,
    fadMobile,
    fadMobileScreen,
    fadWifi,
    fadWifiSlash,
    fadVideo,
    
    // Performance & Cache
    fadFire,
    fadTachometerFast,
    fadSitemap,
    
    // Misc
    fadHandWave,
    fadLaptopFile,
    fadRectangleHistoryCircleUser,
    fadLanguage,
    fadBullhorn,
    fadFlask,
    fadBug,
    fadSignOut,
    fadXmark,
    fadCircleInfo,
    fadScrewdriverWrench,
    fadCakeCandles,
    fadGavel,
    fadSignalStream,
    fadServer,
    fadPuzzlePiece,
    fadStopwatch,
    fadRotate,
  );

  // Thin misc icons
  library.add(
    fatHandWave,
    fatLaptopFile,
    fatArrowDown,
  );
};
